import { Action } from '../types/types';
import { PptxDeckSlideInfo } from '../../utils/pptx-deck-animations-reconcile';

export const SET_PPTX_DECK_ANIMATIONS_INFO = 'SET_PPTX_DECK_ANIMATIONS_INFO';
export function setPptxDeckAnimationsInfo(mediaId: number, slides: PptxDeckSlideInfo[]): Action {
	return {
		type: SET_PPTX_DECK_ANIMATIONS_INFO,
		payload: { mediaId, slides },
	};
}
